<div class="d-flex justify-content-between mat-dialog-header">
    <h2 mat-dialog-title class="bg-white pb-0">
        <i class="fa-light fa-square-poll-horizontal pe-2"></i>{{ 'poll_creation_now.title' | translate }}
    </h2>
    <mat-dialog-actions class="top-action">
      <button type="button" class="btn p-0 border-0 fs-4 text-secondary" (click)="action(null)"><i
          class="fa-regular fa-xmark"></i></button>
    </mat-dialog-actions>
  </div>
  
  <mat-dialog-content class="dialog-content-pad-15 py-1 px-0">     
    <div class="row step-content px-4 gx-4">
        <p class="pb-2 fs-6 text-secondary fst-italic">{{ 'poll_creation_now.preview' | translate }}</p>
        <div class="preview">
            <poll-preview [previewType]="previewType"
                          [poll]="pollForPreview"
                          [author]="authorName"
                          [options]="options"
                          [selectedTeams]="teams"
                          [allowComments]="poll._allowComments"
                          state="postNow"></poll-preview>
        </div>
    </div>
    <div mat-dialog-actions class="d-flex justify-content-center pt-2">
        <button class="btn btn-danger" (click)="action(null)">
            {{'poll_creation_now.cancel' | translate}}
        </button>
        <button class="btn btn-secondary" (click)="action('customize')">
            {{'poll_creation_now.customize' | translate}}
        </button>
        <button class="btn btn-primary" data-cy="publishPool" (click)="action('post')">
            {{'poll_creation_now.confirm' | translate}}
        </button>
      </div>
  </mat-dialog-content>

  